import { NumberInput as ChakraNumberInput } from '@chakra-ui/react'
import { forwardRef } from "react"

export interface NumberInputProps extends ChakraNumberInput.RootProps {
  steppers?: boolean
}

const stopPropagation = (event: React.MouseEvent) => event.stopPropagation()

export const NumberInputRoot = forwardRef<HTMLDivElement, NumberInputProps>(
  function NumberInput(props, ref) {
    const { children, steppers = true, ...rest } = props
    return (
      <ChakraNumberInput.Root ref={ref} variant="outline" {...rest}>
        {children}
        {steppers && (
          <ChakraNumberInput.Control>
            <ChakraNumberInput.IncrementTrigger onClick={stopPropagation} onDoubleClick={stopPropagation} />
            <ChakraNumberInput.DecrementTrigger onClick={stopPropagation} onDoubleClick={stopPropagation} />
          </ChakraNumberInput.Control>
        )}
      </ChakraNumberInput.Root>
    )
  },
)

export const NumberInputField = ChakraNumberInput.Input
export const NumberInputScrubber = ChakraNumberInput.Scrubber
export const NumberInputLabel = ChakraNumberInput.Label
